export default "__VITE_ASSET__1ef1e57f__"